<template>
  <form class="form" id="form">
    <p>{{ subtitle }}</p>
    <div class="form__body">
      <form-input
        :title="'Прізвище та імʼя'"
        :placeholder="'Ваше прізвище та імʼя'"
        :required="true"
        :type="'text'"
        v-model="editData.name"
      />
      <div class="">
        <label>Ваш вік</label>
        <vue-multiselect
          v-model="selectedAge"
          :options="optionsAge"
          placeholder="Ваш вік"
          label="label"
          track-by="label"
          @change="onChangeAge(selectedAge)"
        />
      </div>
      <form-input
        :title="'Електронна пошта або месенджер'"
        :placeholder="'Email'"
        :required="true"
        :type="'text'"
        v-model="editData.email"
      />
      <form-input
        :title="'Номер телефону'"
        :placeholder="'Ваш номер телефону'"
        :required="true"
        :type="'text'"
        v-model="editData.phone"
      />
      <div class="">
        <label>Оберіть спеціальність</label>
        <vue-multiselect
          v-model="selectedSpec"
          :options="optionsSpec"
          placeholder="Ваша спеціальність"
          label="label"
          track-by="label"
          @change="onChangeSpec(selectedSpec)"
        />
      </div>
      <div class="">
        <label>Оберіть підрозділ</label>
        <vue-multiselect
          v-model="selectedDivision"
          :options="optionsDivision"
          placeholder="Ваш підрозділ"
          label="label"
          track-by="label"
          @change="onChangeDivision(selectedDivision)"
        />
      </div>
    </div>
    <custom-radio-list
      style="margin: 20px 0"
      :title="titleRadioBtn"
      name="device-type"
      :items="yesNoList"
      @update:selected="selectYesNoMethod"
    />
    <custom-checkbox
      class="create-push__checkbox local-time"
      v-model="acceptDocs"
      :label="checkboxText"
      @input="changeLocalTimeSend"
    />
    <custom-button
      class="submit-button"
      :is-white="isWhite"
      type="submit"
      @click="sendData"
    >
      Долучитись
    </custom-button>
  </form>
  <div v-if="isModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <button class="modal-close" @click="closeModal">×</button>
      <div class="modal-text">
        <logo-container />
        <h3>Дякуємо, що заповнили анкету</h3>
        <p>Наші рекрутери звʼяжуться з вами найближчим часом</p>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "@/components/UI/CustomButton.vue";
import FormInput from "@/components/main/form/modules/FormInput.vue";
import CustomRadioList from "@/components/main/form/modules/FormRadioButton.vue";
import CustomCheckbox from "@/components/main/form/modules/FormCheckbox.vue";
// import FormSelect from "@/components/main/form/modules/FormSelect.vue";
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import LogoContainer from "@/components/page/modules/LogoContainer.vue"; // Базовые стили
export default {
  name: "form-content",
  components: {
    LogoContainer,
    // FormSelect,
    VueMultiselect,
    CustomCheckbox,
    CustomRadioList,
    FormInput,
    CustomButton,
  },
  props: {
    subtitle: {
      type: String,
      default: () => "",
    },
    isWhite: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isModal: false,
      isModalText: "",
      selectedSpec: "",
      selectYesNo: "",
      optionsSpec: [
        {
          value: "Водій-електрик відділення БпАК",
          label: "Водій-електрик відділення БпАК",
        },
        {
          value: "Зовнішній пілот, оператор БпЛА",
          label: "Зовнішній пілот, оператор БпЛА",
        },
        {
          value: "Інженер-механік БпЛА",
          label: "Інженер-механік БпЛА",
        },
        {
          value: "Майстер-вибухотехнік БпЛА",
          label: "Майстер-вибухотехнік БпЛА",
        },
        {
          value: "Оператор наземних роботизованих комплексів",
          label: "Оператор наземних роботизованих комплексів",
        },
        {
          value: "Поки не визначився",
          label: "Поки не визначився",
        },
      ],
      selectedDivision: "",
      optionsDivision: [
        { value: "420 об БпС", label: "420 об БпС" },
        { value: "30 омбр", label: "30 омбр" },
        { value: "31 омбр", label: "31 омбр" },
        { value: "44 омбр", label: "44 омбр" },
        { value: "72 омбр", label: "72 омбр" },
        { value: "127 обр тро", label: "127 обр тро" },
        { value: "423 об БпС", label: "423 об БпС" },
        { value: "21 омбр", label: "21 омбр" },
        { value: "41 омбр", label: "41 омбр" },
        { value: "57 омпбр", label: "57 омпбр" },
        { value: "56 омпбр", label: "56 омпбр" },
        { value: "419 об БпС", label: "419 об БпС" },
        { value: "24 омбр", label: "24 омбр" },
        { value: "42 омбр", label: "42 омбр" },
        { value: "150 омбр", label: "150 омбр" },
        { value: "68 оєгбр", label: "68 оєгбр" },
        { value: "128 огшбр", label: "128 огшбр" },
        { value: "141 опбр", label: "141 опбр" },
        { value: "125 обр тро", label: "125 обр тро" },
        { value: "130 орб", label: "130 орб" },
        { value: "92 ошбр", label: "92 ошбр" },
        { value: "23 омбр", label: "23 омбр" },
        { value: "43 омбр", label: "43 омбр" },
        { value: "54 омбр", label: "54 омбр" },
        { value: "93 омбр", label: "93 омбр" },
        { value: "17 отбр", label: "17 отбр" },
        { value: "129 обр тро", label: "129 обр тро" },
        { value: "47 омбр", label: "47 омбр" },
        { value: "100 омбр", label: "100 омбр" },
        { value: "3 ошбр", label: "3 ошбр" },
        { value: "4 отбр", label: "4 отбр" },
        { value: "115 омбр", label: "115 омбр" },
        { value: "117 омбр", label: "117 омбр" },
        { value: "118 омбр", label: "118 омбр" },
        { value: "60 омбр", label: "60 омбр" },
        { value: "61 омбр", label: "61 омбр" },
        { value: "63 омбр", label: "63 омбр" },
        { value: "3 отбр", label: "3 отбр" },
        { value: "оПбр", label: "оПбр" },
        { value: "5 ошбр", label: "5 ошбр" },
        { value: "66 омбр", label: "66 омбр" },
        { value: "15 обрар", label: "15 обрар" },
        { value: "2 іл св зсу", label: "2 іл св зсу" },
        { value: "21 обсп", label: "21 обсп" },
        { value: "20 ОПБпС К-2", label: "20 ОПБпС К-2" },
        { value: "43 оабр", label: "43 оабр" },
        { value: "210 ошп", label: "210 ошп" },
        {
          value: '414 ОБрУБАС "Птахи Мадяра"',
          label: '414 ОБрУБАС "Птахи Мадяра"',
        },
        { value: "425 об БпС", label: "425 об БпС" },
        { value: "429 ОПБпС Ахілєс", label: "429 ОПБпС Ахілєс" },
        { value: "427 ОПБпС РАРОГ", label: "427 ОПБпС РАРОГ" },
        { value: "45 оабр", label: "45 оабр" },
      ],
      checkboxText:
        "Погоджуюсь на обробку персональних даних з метою рекрутингу до підрозділів Сухопутних військ",
      titleRadioBtn:
        "Чи перебуваєте Ви в лавах ЗСУ або інших складових Сил оборони України?",
      editData: this.data,
      acceptDocs: false,
      selectedAge: null,
      optionsAge: [
        { value: "18-59", label: "18-59" },
        { value: "До 18", label: "До 18" },
        { value: "Більше 59", label: "Більше 59" },
      ],
      yesNoList: [
        {
          value: "так",
          label: "Так",
        },
        {
          value: "ні",
          label: "Ні",
        },
      ],
    };
  },
  methods: {
    closeModal() {
      this.isModal = false;
    },
    onChangeAge(value) {
      this.selectedAge = value;
    },
    onChangeSpec(value) {
      this.selectedSpec = value;
    },
    onChangeDivision(value) {
      this.selectedDivision = value;
    },
    selectYesNoMethod(value) {
      this.selectYesNo = value;
    },
    changeLocalTimeSend(value) {
      this.acceptDocs = value;
    },
    sendData() {
      const form = document.getElementById("form");

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const formData = new FormData();

        formData.append("name-surname", this.editData.name);
        formData.append("phone", this.editData.phone);
        formData.append("email", this.editData.email);
        formData.append("age", this.selectedAge?.value || "");
        formData.append("obrobka", this.acceptDocs ? "так" : "ні");
        formData.append("military", this.selectYesNo);
        formData.append("work", this.selectedSpec?.value || "");
        formData.append("team", this.selectedDivision?.value || "");

        // URL с параметрами
        const url = `https://script.google.com/macros/s/AKfycbyQSe2kCrNHoGg2wo2lGLpRaE4mfmdgNNPKzRNrYrvBjmBu7yYngAkHRrEkGSEEQbbg1g/exec?p1=${formData.get(
          "name-surname"
        )}&p2=${formData.get("phone")}&p3=${formData.get(
          "email"
        )}&p4=${formData.get("age")}&p5=${formData.get(
          "obrobka"
        )}&p6=${formData.get("military")}&p7=${formData.get(
          "work"
        )}&p8=${formData.get("team")}`;
        // eslint-disable-next-line
        const response = fetch(url, {
          method: "POST",
          body: formData,
        });
        // console.log("Успех:", response);
        this.isModal = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  max-width: 900px;

  p {
    font-family: UAF Sans;
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 24px;

    @media (max-width: 767px) {
      font-size: 18px;
    }
  }

  &__body {
    display: grid;
    gap: 24px;
    grid-template-columns: 438px 438px;

    @media (max-width: 1100px) {
      grid-template-columns: 1fr;
    }
  }
}

.submit-button {
  margin-top: 40px;
}

.simple-select {
  width: 100%;
}

:deep(.multiselect) {
  font-family: "UAF Sans", "HalvarR", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #000;
}

/* Стили для поля ввода/шапки селекта */
:deep(.multiselect__tags) {
  border: 1px solid #1c1c1c;
  background: #fff;
  height: 79px;
  margin: 10px 0;
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-radius: 0;
}

/* Стили для выпадающего списка */
:deep(.multiselect__content-wrapper) {
  background: #fff; /* Белый фон */
  color: #1c1c1c; /* Цвет шрифта */
  width: 100%;
  box-sizing: border-box;
  max-height: 200px; /* Ограничение высоты для скролла */
  overflow-y: auto;
  font-family: "UAF Sans", "HalvarR", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
}

/* Стили для опций в выпадающем списке */
:deep(.multiselect__option) {
  padding: 10px 30px; /* Отступы для читаемости */
  color: #1c1c1c; /* Цвет шрифта */
}

/* Убираем ::after у опций */
:deep(.multiselect__option::after) {
  content: none; /* Убираем псевдоэлемент ::after */
}

/* Подчёркивание при наведении */
:deep(.multiselect__option--highlight) {
  background: #fff; /* Без фона */
  text-decoration: underline; /* Подчёркивание при наведении */
}

/* Стили для выбранной опции — только подчёркивание */
:deep(.multiselect__option--selected) {
  background: #fff; /* Без фона */
  text-decoration: underline; /* Подчёркивание для выбранной опции */
}

/* Убираем лишние элементы */
:deep(.multiselect__spinner) {
  display: none; /* Убираем спиннер */
}

:deep(.multiselect__single) {
  padding-left: 0;
  margin-bottom: 0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  width: 1360px;
  height: 700px;
  background: #1c1c1c;
  display: flex;
  gap: 15px;
  position: relative;
  border-radius: 8px;
  overflow-y: auto;
  box-sizing: border-box;
  border: 1px solid #fff;
  justify-content: center;
  align-items: center;
  @media (max-width: 767px) {
    width: 90%;
  }
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
}

.modal-image {
  width: 100%;
  max-height: 110px;
  object-fit: cover;
  margin-bottom: 15px;
}

.modal-text {
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-text h3 {
  font-family: "UAF Sans H", serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  text-transform: uppercase;
  margin: 8px 0 24px;

  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 22px;
    width: 285px;
    text-align: center;
  }
}

.modal-text p {
  font-family: "UAF Sans H", serif;
  font-weight: 400;
  font-size: 32px;
  line-height: 44px;
  text-align: center;
  width: 700px;

  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 22px;
    width: 285px;
    text-align: center;
  }
}

:deep(.multiselect__select) {
  top: 20px;
}

:deep(.multiselect__placeholder) {
  margin-bottom: 0 !important;
}
</style>
